"use client"
import { useQueryClient } from "@tanstack/react-query";
import { FC, useEffect } from "react";
import type { ModalMessage } from "@/types/data.types";

export type TanstackStateInitializerProps = {
    currentModal?: string;
    modalVideoUrl?: string;
    pricePoint?: number;
    subdivision?: string;
    listingSource?: string;
    resultModal?: ModalMessage;
}

const TanstackStateInitializer: FC<TanstackStateInitializerProps> = ({currentModal, modalVideoUrl, pricePoint, subdivision, resultModal}) => {
    const queryClient = useQueryClient();

    useEffect(() => {
        queryClient.setQueryData(["RES-DATA"], {currentModal, modalVideoUrl, pricePoint, subdivision, resultModal});
    }, [queryClient]);

    return null;
}

export default TanstackStateInitializer;